export default __webpack_public_path__ + "static/media/keyvis_players_left_dt.23b3998e.png";